/**
 * Created by staffanrantzow on 22/09/16.
 */

import Translate from 'react-translate-component';
import React, { PropTypes } from 'react';
import { Spinner, GeneralError } from 'components';
import AgreementsService from 'frilans-finans/agreements/agreement-service';

export class AgreementHtml extends React.Component {

  static propTypes = {
    params: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      fetchError: false,
      agreement: null
    };

    this.fetchAgreement();
  }

  fetchAgreement () {
    if (this.props.params.id) {
      AgreementsService.getById(this.props.params.id)
        .then(this.handleResponse.bind(this))
        .catch(this.handleError.bind(this));
    }
  }

  handleResponse (agreement) {
    this.setState({
      fetching: false,
      agreement: agreement,
      fetchError: false
    });
  }

  handleError () {
    this.setState({
      fetching: false,
      fetchError: true
    });
  }

  createMarkup (html) {
    return {__html: html};
  }

  render () {
    let button;

    if (this.state.fetchError) {
      return (<GeneralError/>);
    }

    if (this.state.fetching) {
      return (
        <Spinner/>
      );
    }

    if (this.state.agreement.pdfUrl) {
      button = <a href={this.state.agreement.pdfUrl} target='_blank' className='btn dl-btn'>
        <Translate content='DOWNLOAD_AS_PDF'/>
      </a>;
    } else {
      button = '';
    }

    return (
      <div className="container agreement">
        {button}
        <div className="row">
          <div className="col-lg-6 col-lg-push-3 col-sm-8 col-sm-push-2">
            <p dangerouslySetInnerHTML={this.createMarkup(this.state.agreement.text)}/>
          </div>
        </div>
      </div>
    );
  }

}

export default AgreementHtml;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/agreements/agreement-html.js
 **/